import { TextAppearance, TextColor, TextCustomProps, TextLineHeight, TextSize, TextTag, TextWeight } from '@vw-marketing/us-components';
import {fieldsConfiguration} from '../../typing/forms';
import {UsedVehicle} from '../../typing/used-inventory';
import { ZipConfig} from '../../typing/zip-types';

export const DEFAULT_MAKE_OFFER_FIELDS = {
  // FORM METADATA
  brand: 'VW',
  formName: 'make_offer_form',
  formType: 'lead',
  providerName: 'vwcpo',
  requestType: 'vwcpo_make_offer',
  saleType: 'cpo',
  sourceType: 'vwcpo',
  subType: '2501',

  //ZIPCODE DATA
  city: '',
  zip: '',
  state: '',

  // DEALER DATA
  dealerId: '',
  dealerName: '',

  // VEHICLE DATA
  modelCode: '',
  modelName: '',
  trim: '',
  vin: '',
  year: '',
  price: '',

  // USER DATA
  email: '',
  firstName: '',
  lastName: '',
  comments: '',
  monthlyFee: '',
  myOffer: '',
  phone: '',
  preferredContactMethod: 'email'
};


export const DEFAULT_CONTACT_DEALER_FIELDS = {
  // FORM METADATA
  brand: 'VW',
  formName: "dealer_contact_form",
  formType: 'lead',
  providerName: 'vwcpo',
  requestType: 'vwcpo_contact-dealer',
  saleType: 'cpo',
  sourceType: 'vwcpo',
  subType: '2502',

  //ZIPCODE DATA
  city: '',
  zip: '',
  state: '',

  // DEALER DATA
  dealerId: '',
  dealerName: '',

  // VEHICLE DATA
  modelCode: '',
  modelName: '',
  trim: '',
  vin: '',
  year: '',
  price: '',

  // USER DATA
  email: '',
  firstName: '',
  lastName: '',
  comments: '',
  phone: '',
  preferredContactMethod: 'email'
};

export const formNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.h1,
  style: {
    fontSize: TextSize.TextSize32,
    lineHeight: TextLineHeight.TextLineHeight36,
    fontWeight: TextWeight.bold,
    color: TextColor.primary
  }
}

export const formBackTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize16,
    lineHeight: TextLineHeight.TextLineHeight20,
    fontWeight: TextWeight.bold,
    color: TextColor.inherit
  }
}

export const formDescriptionTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize12,
    lineHeight: TextLineHeight.TextLineHeight18,
    fontWeight: TextWeight.regular,
    color: TextColor.primary
  }
}



export const getFieldsConfiguration = (
  fields: fieldsConfiguration,
  vehicle?: UsedVehicle,
  zip?: ZipConfig,
): fieldsConfiguration => {
  return {
    ...fields,
    city: zip?.city || '',
    zip: zip?.zip|| '',
    state: zip?.state || '',
    dealerId: vehicle?.dealer?.dealerid || '',
    dealerName: vehicle?.dealer?.name || '',
    modelCode: vehicle?.modelCode || '',
    modelName: vehicle?.model || '',
    trim: vehicle?.trimLevel || '',
    vin: vehicle?.vin || '',
    year: vehicle?.modelYear || '',
    price: vehicle?.adjustedListPrice || '',
  };
};
